import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { NTA_COLORS } from '../constants';
import { ntaPageCss } from '../typography';

const CHEVRON_SRC = '/nta-experience/palette-collapse-chevron.svg';

const Track = styled.div`
  width: 20px;
  align-self: stretch;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  ${ntaPageCss}
`;

const Toggle = styled.button`
  width: 20px;
  height: 56px;
  padding: 0;
  box-sizing: border-box;
  border: none;
  border-radius: 8px;
  background: ${NTA_COLORS.textPrimary};
  box-shadow: 0 2px 8px rgba(60, 72, 82, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
  ${ntaPageCss}

  &:hover {
    background: ${NTA_COLORS.accentBlue};
    box-shadow: 0 4px 12px rgba(45, 129, 247, 0.28);
  }

  &:active {
    transform: scale(0.96);
  }

  &:focus-visible {
    outline: 2px solid ${NTA_COLORS.accentBlue};
    outline-offset: 2px;
  }
`;

const ChevronIcon = styled.img`
  width: 8px;
  height: 14px;
  display: block;
  object-fit: contain;
  transform: ${({ $collapsed }) => ($collapsed ? 'rotate(180deg)' : 'none')};
  transition: transform 0.2s ease;
`;

const NtaPaletteCollapse = ({ collapsed, onToggle }) => (
  <Track>
    <Toggle
      type="button"
      onClick={onToggle}
      aria-expanded={!collapsed}
      aria-label={
        collapsed ? 'Expand question palette' : 'Collapse question palette'
      }
      title={collapsed ? 'Show question palette' : 'Hide question palette'}
    >
      <ChevronIcon
        src={CHEVRON_SRC}
        width={8}
        height={14}
        alt=""
        $collapsed={collapsed}
        aria-hidden
      />
    </Toggle>
  </Track>
);

export default NtaPaletteCollapse;

NtaPaletteCollapse.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};
